import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from './service/api.service';

// export interface PeriodicElement {
//   api_id: number;
//   api_name: string;
//   link_api: number;
// }

// const ELEMENT_DATA: PeriodicElement[] = [
//   {api_id: 1, api_name: 'Hydrogen', link_api: 1.0079},
//   {api_id: 2, api_name: 'Helium', link_api: 4.0026},
//   {api_id: 3, api_name: 'Lithium', link_api: 6.941},
// ];

@Component({
  selector: 'app-api',
  templateUrl: './api.component.html',
  styleUrls: ['./api.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ApiComponent implements OnInit {

  displayedColumns: string[] = ['api_id', 'api_name', 'link_api', 'action'];
  // dataSource;
  dataSource;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    public dialog: MatDialog,
    private _api: ApiService
  ) { }

  ngOnInit() {
    // this.dataSource.paginator = this.paginator;
    this.getAPI()
  }

  getAPI() {
    this._api.getAPIAll().subscribe(apis => {
      console.log(apis['message']);
      this.dataSource = new MatTableDataSource(apis['message'])
      this.dataSource.paginator = this.paginator;
    })
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  dialog_addAPI() {
    const dialogRef = this.dialog.open(dialog_add_api, {
      width: '40%',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getAPI()
    })
  }

  dialog_editAPI(data: any) {
    localStorage.setItem('dataEdit', JSON.stringify(data))
    // console.log(data);
    const dialogRef = this.dialog.open(dialog_edit_api, {
      width: '40%',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getAPI()
      localStorage.removeItem('dataEdit')
    })
  }

  // // Dialog Delete
  dialog_deleteAPI(id: any): void {
    localStorage.setItem('id', id)
    const dialogRef = this.dialog.open(dialog_delete_api, {
      width: '710px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getAPI()
      localStorage.removeItem('id')
    })
  }

}

@Component({
  selector: 'dialog_add_api',
  templateUrl: 'dialog-add-api.html',
  styleUrls: ['api.component.scss']
})
export class dialog_add_api implements OnInit {
  // ceate form add
  formAdd: FormGroup;
  url = `${environment.apiUrl}/api`;

  custom_film: boolean = false

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    public dialogRef: MatDialogRef<dialog_add_api>,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar
  ) {
    this.formAddAPI()
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private formAddAPI() {
    this.formAdd = this.formBuilder.group({
      api_name: ['', Validators.required],
      link_api: ['', Validators.required],
    })
  }

  addAPI() {
    console.log(this.formAdd.value);
    if (this.formAdd.invalid) return;
    this.http.post(this.url, this.formAdd.value, this.httpOptions).subscribe(res => {
      console.log(res);
      this.onNoClick()
      this._snackBar.open('Add API success.', 'Done', {
        duration: 3000,
      });
    }, err => {
      console.log(err);
      this._snackBar.open('Add API fail!.', 'Done', {
        duration: 3000,
      });
    })
  }

}

@Component({
  selector: 'dialog_edit_api',
  templateUrl: 'dialog-edit-api.html',
  styleUrls: ['api.component.scss']
})
export class dialog_edit_api implements OnInit {
  data_edit = JSON.parse(localStorage.getItem('dataEdit'))
  // ceate form add
  formEdit: FormGroup;
  url: any;

  custom_film: boolean = false

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    public dialogRef: MatDialogRef<dialog_edit_api>,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar
  ) {
    this.formAddAPI()
  }

  ngOnInit() {
    this.setDataEdit()
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private formAddAPI() {
    this.formEdit = this.formBuilder.group({
      api_id : [''],
      api_name: ['', Validators.required],
      link_api: ['', Validators.required],
    })
  }

  setDataEdit() {
    this.formEdit.controls['api_id'].setValue(this.data_edit['api_id'])
    this.formEdit.controls['api_name'].setValue(this.data_edit['api_name'])
    this.formEdit.controls['link_api'].setValue(this.data_edit['api_link'])
    // console.log(this.formEdit.value);
    this.url = `${environment.apiUrl}/api?api_id=${this.data_edit['api_id']}`
  }

  EditAPI() {
    console.log(this.formEdit.value);
    if (this.formEdit.invalid) return;
    this.http.put(this.url, this.formEdit.value, this.httpOptions).subscribe(res => {
      console.log(res);
      this.onNoClick()
      this._snackBar.open('Edit API success.', 'Done', {
        duration: 3000,
      });
    }, err => {
      console.log(err);
      this._snackBar.open('Edit API fail!.', 'Done', {
        duration: 3000,
      });
    })
  }

}

@Component({
  selector: 'dialog_delete_api',
  templateUrl: 'dialog-delete-api.html',
  styleUrls: ['api.component.scss']
})
export class dialog_delete_api implements OnInit {
  data_id = localStorage.getItem('id')
  delete_API = `${environment.apiUrl}/api?api_id=${this.data_id}`;

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    public dialogRef: MatDialogRef<dialog_delete_api>,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar
  ) {
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteAPI() {
    this.http.delete(this.delete_API, this.httpOptions).subscribe(data => {
      // console.log('Delete Success', data);
      this.onNoClick()
      this._snackBar.open('Delete api success.', 'Done', {
        duration: 3000,
      });
    }, err => {
      console.log(err);
      this._snackBar.open('Delete api fail!.', 'Done', {
        duration: 3000,
      });
    })
  }

}
